import { Selector } from '@ngxs/store';
import { UsuarioCertificadoState } from './usuario-certificado.state';
import { UsuarioCertificadoStateModel } from './usuario-certificado-state.model';
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

export class UsuarioCertificadoSelector {
    @Selector([UsuarioCertificadoState])
    public static tipoAutenticacaoSelecionado(state: UsuarioCertificadoStateModel): EnumTipoAutenticacaoEnvioPortalUnico {
        return state.tipoAutenticacaoSelecionado;
    }
    
    @Selector([UsuarioCertificadoState])
    public static modalSenhaConfirmado(state: UsuarioCertificadoStateModel): boolean {
        return state.modalSenhaConfirmado;
    }
}
